module.exports = __webpack_public_path__ + "static/media/available-icon.12de8760.svg";